// --- UPDATED FILE: packages/api-client/src/services/public/goalService.ts ---

import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { 
    ServiceResponse, 
    PublicGoalsDashboardResponse,
    PublicGoalHistoryResponse,
} from '@dopomogai/types';

const PUBLIC_GOALS_PREFIX = '/goals';

export const goalService = {
  /**
   * Fetches all public goal definitions, hydrated with their translations.
   * @param locale The desired language for the translations.
   */
  listGoalDefinitions: (locale: string): ServiceResponse<PublicGoalsDashboardResponse> => {
    return getApiClient().get<PublicGoalsDashboardResponse>(`${PUBLIC_GOALS_PREFIX}/definitions`, { params: { locale } })
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing public goal definitions'));
  },

  /**
   * Fetches the historical data for a single goal, hydrated with its definition
   * and the global language pack.
   * @param goalId The unique ID of the goal.
   * @param locale The desired language for the translations.
   * @param params Optional date filters.
   */
  getGoalHistory: (goalId: string, locale: string, params?: { start_date?: string, end_date?: string }): ServiceResponse<PublicGoalHistoryResponse> => {
    const allParams = { ...params, locale };
    return getApiClient().get<PublicGoalHistoryResponse>(`${PUBLIC_GOALS_PREFIX}/${goalId}/history`, { params: allParams })
      .then(res => res.data)
      .catch(err => handleApiError(err, `fetching history for goal ${goalId}`));
  },
};